import { LuxIconType, LuxToast } from '@gemini/fe-ds-core';

interface OnlineBookingToastProps {
  title: string;
  description?: string;
  severity?: 'warning' | 'error' | 'success' | 'info';
  icon?: LuxIconType;
  showCloseIcon?: boolean;
  open: boolean;
  onClose: () => void;
}

export const OnlineBookingToast = ({
  title,
  description,
  severity = 'warning',
  icon = 'InformationIcon',
  showCloseIcon = true,
  open,
  onClose,
}: OnlineBookingToastProps) => {
  return (
    <LuxToast
      open={open}
      onClose={(_, reason) => {
        if (reason === 'onCloseClick') {
          onClose();
        }
      }}
      duration={5000}
      vertical="bottom"
      horizontal="left"
      severity={severity}
      icon={icon}
      primaryMessage={title}
      secondaryMessage={description}
      showCloseIcon={showCloseIcon}
      snackbarStyle={{
        position: 'absolute',
        bottom: 'calc(100% + 1rem)',
      }}
      width={'auto'}
    />
  );
};
